import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full w-full px-4 md:mx-0 pt-6 xl:pt-[88px] pb-6" }
const _hoisted_2 = { class: "relative items-center w-full min-h-8 mb-6 md:hidden flex" }
const _hoisted_3 = { class: "absolute left-0" }
const _hoisted_4 = { class: "mx-auto text-2xl font-semibold leading-[32px] text-brown" }
const _hoisted_5 = { class: "text-left bg-white rounded-[20px] pb-6 pt-6 md:pt-[30px] flex flex-col items-center md:mx-auto w-full lg:w-[812px] h-full overflow-y-auto px-4 md:px-10" }
const _hoisted_6 = { class: "relative items-center w-full mb-10 hidden md:flex" }
const _hoisted_7 = { class: "absolute left-0" }
const _hoisted_8 = { class: "mx-auto text-2xl font-semibold leading-[32px] text-brown" }

import { ref } from "vue";
import { RuneOfTheDayResponse } from "@/types/calculators";
import { fetchDayRunePredictions } from "@/api/calculators";
import BackButton from "@/components/buttons/BackButton.vue";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { useI18n } from "vue-i18n";
import DayRuneResult from "@/views/Calculators/DayRunePrediction/components/DayRuneResult.vue";
import DayRuneInstruction from "@/views/Calculators/DayRunePrediction/components/DayRuneInstruction.vue";
import { useSafeBack } from "@/utils/useSafeBack";
import { ROUTE_NAMES } from "@/constants/routeNames";


export default /*@__PURE__*/_defineComponent({
  __name: 'DayRunePredictionView',
  setup(__props) {

const { t } = useI18n();
const { safeBack } = useSafeBack();

const dailyRandom = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const runePrediction = ref<RuneOfTheDayResponse | null>(null);

async function handleSubmit() {
  if (isLoading.value) {
    return;
  }
  isLoading.value = true;
  try {
    runePrediction.value = await fetchDayRunePredictions(dailyRandom.value);
  } finally {
    isLoading.value = false;
  }
}

function handleBack() {
  if (runePrediction.value) {
    runePrediction.value = null;
    return;
  }
  safeBack(ROUTE_NAMES.HOME);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BackButton, { onClicked: handleBack })
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)("calculators.day-rune.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BackButton, { onClicked: handleBack })
        ]),
        _createElementVNode("h2", _hoisted_8, _toDisplayString(_unref(t)("calculators.day-rune.title")), 1)
      ]),
      (!runePrediction.value)
        ? (_openBlock(), _createBlock(GradientButton, {
            key: 0,
            class: "w-[245px] min-h-14 mb-10",
            "bg-color": "bg-brown-gradient",
            "hover-bg-color": "bg-orange-gradient",
            text: _unref(t)('calculators.day-rune.get_rune_btn'),
            onClick: handleSubmit,
            "is-loading": isLoading.value
          }, null, 8, ["text", "is-loading"]))
        : (_openBlock(), _createBlock(DayRuneResult, {
            key: 1,
            prediction: runePrediction.value
          }, null, 8, ["prediction"])),
      _createVNode(DayRuneInstruction)
    ])
  ]))
}
}

})